import { useEffect } from "react";
import { useMap } from "react-leaflet";
import L from "leaflet";
import "leaflet.heat";

// Shaded density heat layer along the trail — highlights where the food + bike
// businesses cluster most richly. Plain-Leaflet plugin driven imperatively.
export default function HeatLayer({ points = [], enabled }) {
  const map = useMap();
  useEffect(() => {
    if (!map || !enabled || points.length === 0) return undefined;
    const heat = L.heatLayer(points, {
      radius: 28, blur: 18, maxZoom: 16, minOpacity: 0.35,
      gradient: { 0.2: "#22d3ee", 0.4: "#84cc16", 0.6: "#facc15", 0.8: "#f97316", 1.0: "#ef4444" },
    });
    heat.addTo(map);
    return () => { try { map.removeLayer(heat); } catch (e) { /* map torn down */ } };
  }, [map, points, enabled]);
  return null;
}
